import * as brandColors from '../../../utils/brand-colors';

export default () => ({
  statusContainer: {
    display: 'flex',
    flexDirection: 'row',
    minWidth: '120px',
  },
  status: {
    margin: 0,
    color: brandColors.grey.dark,
    flex: 1,
    lineHeight: 1.4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  statusIcon: { marginRight: '.25em' },
  eventStatusComment: {
    color: '#fff',
    display: 'inline-block',
    padding: '4px 4px 0 12px',
    fontSize: '10px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    lineHeight: 1,
    borderRadius: '12px',
    verticalAlign: 'baseline',
    margin: '.2em',
  },
  commentText: {
    display: 'inline-block',
    fontSize: 12,
    flex: 1,
    lineHeight: '15px',
    verticalAlign: 'middle',
    margin: '0 .5em',
    color: brandColors.grey.main,
    maxWidth: 200,
    height: 25,
  },
  commentIcon: {
    fontSize: '15px',
    lineHeight: '15px',
    verticalAlign: 'middle',
  },
  statusDate: {
    fontSize: '13px',
    color: brandColors.grey.main,
    marginRight: '1em',
  },
  duration: {
    fontSize: '13px',
    color: brandColors.grey.main,
    display: 'flex',
  },
  timeContainer: { display: 'flex' },
  statusDurationIcon: {
    fontSize: '16px',
    color: brandColors.grey[400],
  },
  statusWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
});
